import { useTranslations } from "use-intl";
import Button from "@/shared/form/button";
import { EditFilled } from "@ant-design/icons";

type HtmlTemplateEditorButton = {
  onOpen: () => void;
};

export default function OpenHtmlTemplateEditorButton({
  onOpen,
}: HtmlTemplateEditorButton) {
  const t = useTranslations("OpenHtmlTemplateEditorButton");

  return (
    <Button success type="primary" onClick={onOpen} icon={<EditFilled />}>
      {t("Open editor")}
    </Button>
  );
}
